import { computeTotalHoursOnBoard } from '../../computations/labComputations'
import React from 'react'
import { useTranslation } from 'react-i18next'

// ---------------------------------------------------------------------------
// Mock values — will be replaced by real data from the vessel info section
// (General tab) once that is implemented.
// ---------------------------------------------------------------------------
const MOCK_SURVEY_LOG = [
  {
    labelKey: 'rob.survey.bunker.lab.surveyLog.vesselBerthed',
    value: '10:06:2026 14:30',
  },
  {
    labelKey: 'rob.survey.bunker.lab.surveyLog.surveyorBoarded',
    value: '10:06:2026 15:00',
  },
  {
    labelKey: 'rob.survey.bunker.lab.surveyLog.bunkerBargeAlongside',
    value: '10:06:2026 15:30',
  },
  {
    labelKey: 'rob.survey.bunker.lab.surveyLog.hoseConnected',
    value: '10:06:2026 16:00',
  },
  {
    labelKey: 'rob.survey.bunker.lab.surveyLog.commencedBunkering',
    value: '10:06:2026 16:15',
  },
  {
    labelKey: 'rob.survey.bunker.lab.surveyLog.completedBunkering',
    value: '11:06:2026 04:45',
  },
  {
    labelKey: 'rob.survey.bunker.lab.surveyLog.hoseDisconnected',
    value: '11:06:2026 05:00',
  },
  {
    labelKey: 'rob.survey.bunker.lab.surveyLog.surveyorLeftVessel',
    value: '11:06:2026 05:30',
  },
]

const TOTAL_HOURS = computeTotalHoursOnBoard(
  MOCK_SURVEY_LOG[1].value, // surveyorBoarded
  MOCK_SURVEY_LOG[7].value // surveyorLeftVessel
)

const LabSurveyLogSection = () => {
  const { t } = useTranslation()

  return (
    <div className="lab-card">
      {/* Two-column header */}
      <div className="lab-card__header lab-card__header--two-col">
        <span>{t('rob.survey.bunker.lab.surveyLog.title')}</span>
        <span>{t('rob.survey.bunker.lab.surveyLog.dateTimeHeader')}</span>
      </div>

      <div className="lab-card__body">
        {MOCK_SURVEY_LOG.map(({ labelKey, value }) => (
          <div className="lab-form-row" key={labelKey}>
            <span className="lab-form-row__label lab-form-row__label--teal">
              {t(labelKey)}
            </span>
            <span className="lab-form-row__readonly">{value}</span>
          </div>
        ))}

        {/* Total hours on board — derived from mock boarded / left timestamps */}
        <div className="lab-form-row lab-form-row--total">
          <span className="lab-form-row__label lab-form-row__label--bold">
            {t('rob.survey.bunker.lab.surveyLog.totalHoursOnBoard')}
          </span>
          <span className="lab-form-row__total">{TOTAL_HOURS}</span>
        </div>
      </div>
    </div>
  )
}

export default LabSurveyLogSection
